import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=2d8d3b51&scoped=true&"
import script from "./TopHeader.vue?vue&type=script&lang=js&"
export * from "./TopHeader.vue?vue&type=script&lang=js&"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=2d8d3b51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d3b51",
  null
  
)

export default component.exports